import React, { lazy, Suspense, useEffect, useState } from "react";
import { useHasWindow } from "@litres-libs/global-hooks";
import type { IPopoverProps } from "./types";

const PopoverInner = lazy(() => import("./PopoverInner"));

interface ISeoMarkupProps {
  content: React.ReactNode;
}
const SeoMarkup = ({ content }: ISeoMarkupProps) => {
  // смещение нужно, потому что без него в ssr на странице автора
  // появляется горизонтальная полоса прокрутки в мобильной версии
  return (
    <div style={{ visibility: "hidden", position: "absolute", left: "-150px" }}>
      {content}
    </div>
  );
};

export const Popover = (props: IPopoverProps) => {
  const hasWindow = useHasWindow();
  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  if (isFirstRender) {
    return (
      <>
        {props.children}
        {props.needForSEO && !hasWindow && (
          <SeoMarkup content={props.content} />
        )}
      </>
    );
  }

  return (
    <Suspense fallback={props.children}>
      <PopoverInner {...props} />
    </Suspense>
  );
};
